import ImageContent from './ImageContent';

export default ImageContent;
